module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-form__form-group-item"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.form[_vm.$parent.address].firstname),
      expression: "$parent.form[$parent.address].firstname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$parent.$v.form[_vm.$parent.address].firstname.$error
    },
    attrs: {
      "type": "text",
      "name": "prename"
    },
    domProps: {
      "value": (_vm.$parent.form[_vm.$parent.address].firstname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$parent.form[_vm.$parent.address], "firstname", $event.target.value.trim())
      }, function($event) {
        _vm.$parent.$v.form[_vm.$parent.address].firstname.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "prename"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("\n            Vorname\n        ")]), _c('span', {
    staticClass: "required-symbol"
  }, [_c('span', {
    staticClass: "sr-only",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("(Pflichtfeld)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8736702","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Fields/Prename.vue
// module id = 811
// module chunks = 0